module.exports = __webpack_public_path__ + "cc6c84fc6928f8979ab7b7323d29ec92.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-ultralight-italic.ttf
// module id = 94
// module chunks = 0